import { createContext } from 'react';

/**
 * Supported timestamp render formats. Declared as a `const` tuple so the
 * literal union type is derived from a single source of truth and the
 * provider can validate persisted values against it. The array order is also
 * the radiogroup display order in Settings → Preferences → Appearance.
 */
export const TIMESTAMP_FORMATS = ['relative', 'absolute'] as const;

export type TimestampFormat = (typeof TIMESTAMP_FORMATS)[number];

export interface TimestampFormatContextType {
  value: TimestampFormat;
  setValue: (format: TimestampFormat) => void;
}

/**
 * Context default keeps provider-less renders — and the many unit tests that
 * mount `RelativeTimeWithTooltip` without a provider — on the relative form,
 * which is byte-equivalent to today's behavior. The no-op setter is replaced
 * by `TimestampFormatProvider`.
 */
export const TimestampFormatContext = createContext<TimestampFormatContextType>(
  {
    value: 'relative',
    setValue: () => {},
  }
);
